"use client";

import {
  SearchIconWrapper,
  SearchInput,
  SearchInputWrapper,
} from "@/components/Search/SearchField/styles";
import type { SearchProps } from "@/components/Search/SearchField/types";
import { Button, SvgCloseCross, SvgMagnifyingGlass } from "@getgrover/ui";
import { useTranslations } from "next-intl";

export const SearchField = ({
  name,
  value,
  onClick,
  onChange,
  onInput,
  onClose,
  onBlur,
  autoFocus,
  size = "small",
  showCancelButton = false,
}: SearchProps) => {
  const t = useTranslations("header");

  const handleClick = () => {
    onClick?.();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event);
  };

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInput?.(event);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onBlur?.(event);
  };

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClose?.();
  };

  return (
    <SearchInputWrapper htmlFor="searchField" $size={size}>
      <SearchIconWrapper>
        <SvgMagnifyingGlass />
      </SearchIconWrapper>
      <SearchInput
        value={value}
        name={name}
        id="searchField"
        type="search"
        aria-label={t("aria_label.search")}
        autoFocus={autoFocus}
        onClick={handleClick}
        onChange={handleChange}
        onInput={handleInput}
        onBlur={handleBlur}
        placeholder={t("search_placeholder")}
        data-dd-privacy="allow"
      />
      {showCancelButton && (
        <Button iconOnly size="M" variant="Secondary" onClick={handleClose}>
          <SvgCloseCross />
        </Button>
      )}
    </SearchInputWrapper>
  );
};
